var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAigDailyCheck = function SvgIconAigDailyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#ECF4FE",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M28.78 23.018c.103.319.154.65.154.98h5.358c0-.31-.09-.62-.272-.89l-8.696-12.904a1.57 1.57 0 0 0-1.05-.673q.078.013.154.032z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "M19.22 23.017 23.57 9.563c-.348.096-.67.306-.896.64L13.98 23.109c-.182.269-.273.58-.273.89h5.358c0-.33.052-.662.155-.98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M19.22 24.986a3.2 3.2 0 0 1-.155-.986h-5.358c0 .312.09.625.273.895l8.695 12.9c.259.384.643.602 1.05.673q-.077-.013-.154-.032z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M28.935 24c0 .333-.052.665-.155.986l-4.352 13.45q-.076.02-.154.032c.407-.07.792-.29 1.05-.673l8.696-12.9c.182-.27.273-.583.273-.895z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "M24.976 10.204 33.49 23.11c.181.269.272.58.273.89h.528c0-.31-.09-.621-.272-.89l-8.696-12.905a1.55 1.55 0 0 0-.892-.63l.053.166c.188.113.357.265.49.464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M33.764 24c0 .312-.09.625-.273.895l-8.515 12.9a1.55 1.55 0 0 1-.49.464l-.054.166c.346-.095.668-.297.892-.63l8.696-12.9c.182-.27.273-.583.272-.895z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M19.065 24h9.87c0-.332-.052-.663-.155-.982L24.43 9.564a1.73 1.73 0 0 0-.857 0L19.22 23.018c-.103.32-.154.65-.155.982"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M23.826 9.52c-.151.015-.192.029-.254.043L19.22 23.018c-.103.319-.154.65-.155.98h.992c0-.33.052-.661.155-.98z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M28.78 24.986c.104-.32.155-.653.155-.986h-9.87c0 .333.052.665.155.986l4.352 13.45c.258.072.594.073.857 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M23.826 38.474c-.189-.02-.194-.033-.254-.044L19.22 24.975a3.2 3.2 0 0 1-.155-.98h.992c0 .33.052.661.155.98z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "m24.432 9.574 4.348 13.444a3.2 3.2 0 0 1 .154.981h.677c0-.33-.051-.662-.155-.98z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M23.077 9.795c-.152.106-.29.243-.402.41L13.98 23.11c-.182.27-.273.58-.273.891h.92c0-.31.09-.622.272-.89z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "m24.432 38.425 4.347-13.444a3.2 3.2 0 0 0 .155-.981h.677a3.2 3.2 0 0 1-.155.981z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M23.077 38.205a1.6 1.6 0 0 1-.402-.41L13.98 24.89a1.6 1.6 0 0 1-.273-.891h.92c0 .31.09.622.272.89z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.976 17.106-4.65-6.902c-.65-.94-2.037-.912-2.651 0l-7.938 11.78c7.961.487 12.574-1.887 15.239-4.878",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-daily-check_svg__a)",
    d: "M22.706 20.164a2.784 2.784 0 1 0 0-5.568 2.784 2.784 0 0 0 0 5.568",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-daily-check_svg__b)",
    d: "m23.129 17.6.804 1.007-1.006-.805-.221 1.996-.221-1.996-1.007.805.806-1.006-1.997-.221 1.997-.222-.806-1.006 1.007.805.22-1.996.222 1.996 1.006-.805-.804 1.006 1.995.222z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-daily-check_svg__c)",
    d: "M19.01 30.643a42 42 0 0 0 2.208 3.367 42.8 42.8 0 0 0-4.095-6.936 42 42 0 0 0 1.887 3.569"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-daily-check_svg__d)",
    d: "M26.026 32.816a3.71 3.71 0 1 0 0-7.42 3.71 3.71 0 0 0 0 7.42",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-daily-check_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(22.705 17.38)scale(2.784)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-daily-check_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(22.706 17.38)scale(2.41872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-daily-check_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(26.026 29.106)scale(3.71019)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-AIG-daily-check_svg__c",
    x1: 18.345,
    x2: 16.399,
    y1: 27.842,
    y2: 30.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconAigDailyCheck;